import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
// Create lazily loadable FolderPermissions chunk.
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FolderPermissions" */ './lazyIndex');
});
export { default as folderPermissionsStore } from './store/store';
/**
 * Action which others can use to open folder permissions dialog.
 * It gets lazily loaded with the 'FolderPermissions' chunk.
 * @param folderId string - Id of folder for which folder permissions should be shown/updated.
 * @return folderId: string.
 */
export var lazyOpenFolderPermissions = new LazyImport(lazyModule, function (m) { return m.openFolderPermissionsDialog; });
/**
 * This component show Folder Permissions Dialog in UI.
 * It gets lazily loaded with the 'FolderPermissions' chunk.
 */
export var LazyFolderPermissionsDialog = createLazyComponent(lazyModule, function (m) { return m.FolderPermissionsDialog; });
export { default as PERMISSION_CONSTANTS } from './utils/permissionConstants';
//# sourceMappingURL=index.js.map